import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g transform="scale(1.72, 1.72)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.342426 7.27799C0.338305 3.59799 3.31496 0.607991 6.99496 0.603871C10.6816 0.599743 13.6716 3.58306 13.6758 7.26306C13.6799 10.9431 10.6966 13.9331 7.00989 13.9372C3.32989 13.9413 0.346546 10.958 0.342426 7.27799ZM6.33922 4.41792C6.33892 4.15125 6.55201 3.93768 6.81868 3.93738L6.85868 3.93734C7.12535 3.93704 7.33892 4.15013 7.33922 4.4168L7.34261 7.44346L9.92432 8.97391C10.1578 9.10698 10.2315 9.4069 10.0917 9.63372C9.95865 9.86054 9.66539 9.92753 9.43857 9.79445L6.67005 8.13755C6.46325 8.01778 6.343 7.79792 6.34274 7.56458L6.33922 4.41792Z"
      fill={fill}
    />
  </g>
);

export default Icon;
